"use strict";
import { useTokenBalancesQuery } from "appGraphql/data/apollo/AdaptiveTokenBalancesProvider";
export function useTotalBalancesUsdForAnalytics() {
  return useTokenBalancesQuery({ cacheOnly: true }).data?.portfolios?.[0]?.tokensTotalDenominatedValue?.value;
}
